import {Action, Module, Mutation} from 'vuex-module-decorators'
import {MdbsCore} from "@/api/tsclient";
import store, {alertModule} from "@/store";
import BaseModule from "@/store/modules/BaseModule";
import RoleDto = MdbsCore.RoleDto;
import RoleCreateDto = MdbsCore.RoleCreateDto;
import RoleUpdateDto = MdbsCore.RoleUpdateDto;
import IRoleCreateDto = MdbsCore.IRoleCreateDto;
import IRoleUpdateDto = MdbsCore.IRoleUpdateDto;

const roleClient = new MdbsCore.RoleClient();

@Module({namespaced: true, name: "roles", store: store})
export default class RolesModule extends BaseModule {
    roles: Array<RoleDto> = [];

    get roleById() {
        const that = this;
        return function (roleId: string | undefined) {
            if (!roleId)
                return undefined;
            return that.roles.find(r => r.id == roleId);
        };
    }

    @Mutation
    setRoles(roles: Array<RoleDto>) {
        this.roles.updateValues(roles);
    }

    @Mutation
    resetRoles() {
        this.roles.clear();
    }

    @Action({rawError: true})
    async loadAll(includeDeactivated?: boolean) {
        this.startLoading();
        try {
            this.context.commit('setRoles', await roleClient.getAllRoles(includeDeactivated))
        } catch (e) {
            console.error("roles: loadall", e);
            this.resetRoles();
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action({rawError: true})
    async createRole(roleDto: IRoleCreateDto) {
        this.startLoading();
        try {
            await roleClient.create(new RoleCreateDto(roleDto));
            await this.loadAll()
        } catch (e) {
            console.error("role: create", e);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action({rawError: true})
    async getRoleById(roleId: string) {
        try {
            return roleClient.findRole(roleId)
        } catch (e) {
            console.error("role: get by id", e);
            await alertModule.handleException(e);
        }
        return null;
    }

    @Action({rawError: true})
    async getRoleByName(roleName: string) {
        try {
            return roleClient.findRoleByName(roleName)
        } catch (e) {
            console.error("role: get by name", e);
            await alertModule.handleException(e);
        }
        return null;
    }

    @Action({rawError: true})
    async updateRole(roleDto: IRoleUpdateDto) {
        this.startLoading();
        try {
            await roleClient.update(roleDto.id, new RoleUpdateDto(roleDto));
            await this.loadAll()
        } catch (e) {
            console.error("role: update", e);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action({rawError: true})
    async deleteRole(roleId: string) {
        this.startLoading();
        try {
            await roleClient.delete(roleId);
            await this.loadAll();
        } catch (e) {
            console.error("role: deactivate", e);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }
}
